"use client";

import "@/public/css/global/bootstrap.min.css";
import "@/public/css/global/all.min.css";
import "@/public/css/global/line-awesome.min.css";
import "@/public/css/global/select2.min.css";
import "@/public/css/global/secure-password.css";
import "@/public/css/frontend/main.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import HandleFrontendChildren from "./HandleFrontendChildren";
import { SessionProvider } from "next-auth/react";
import { Provider } from "react-redux";
import LoadGlobalData from "../_partials/LoadGlobalData";
import SetLanguage from "../_partials/SetLanguage";
import SetCustomPages from "../_partials/SetCustomPages";
import { store } from "@/store";
import WhatsAppWidget from "../_partials/WhatsAppWidget";
import MaintenanceGuard from "../_partials/MaintenanceGuard";

export default function FrontendLayout({ children }) {
  const authPrefix = process.env.NEXT_PUBLIC_AUTH_PREFIX;

  let basePath;

  if (authPrefix === "/" || !authPrefix) {
    basePath = "/api/auth";
  } else {
    basePath = `${authPrefix}/api/auth`;
  }

  return (
    <html>
      <body suppressHydrationWarning>
        <SessionProvider basePath={basePath}>
          <Provider store={store}>
            <LoadGlobalData />
            <SetLanguage />
            <SetCustomPages />
            <HandleFrontendChildren>{children}</HandleFrontendChildren>
            <MaintenanceGuard />
            <WhatsAppWidget />
          </Provider>
        </SessionProvider>
      </body>
    </html>
  );
}
